import React, { useState } from 'react';
import { Modal } from '../common/modal';
import Button from '../common/button';

import noImage from '../../assets/no-image.jpg';

const storeUrl = process.env.STORE_URL;

const FabricModal = ({
  option,
  price,
  isShow,
  setIsShow,
  mainImage,
  setMainImage
}) => {
  return (
    <Modal isShow={isShow} setIsShow={setIsShow}>
      <div className="d-flex flex-column detail-row__modal-wrapper">
        <div className="detail-row__modal overflow-auto p-4">
          <div>
            <div className="detail-row__modal--image">
              <img src={mainImage} alt="fabric-image" />
            </div>
            <div className="detail-row__images-thumbnails">
              <img
                src={option.image_url_1}
                onClick={() => setMainImage(option.image_url_1)}
                className="thumbnail-image"
              />
              <img
                src={option.image_url_2}
                onClick={() => setMainImage(option.image_url_2)}
                className="thumbnail-image"
              />
              <img
                src={option.image_url_3}
                onClick={() => setMainImage(option.image_url_3)}
                className="thumbnail-image"
              />
            </div>
            <div className="grid-collection__meta text-center mt-3 mb-4">
              <div className="grid-collection__title">
                {option.title}
              </div>
              {price && <div className="grid-collection__price">{price}</div>}
            </div>
            <table className="detail-row__modal--table">
              <tbody>
                {Object.entries({
                  ID: option.product_number,
                  Fabric: option.cloth,
                  Color: option.color,
                  Pattern: option.pattern,
                  Material: option.material,
                  Brand: option.brand,
                  Yarn: option.yarn_count
                }).map(([key, value]) => (
                  <tr key={key}>
                    <td>{key}</td>
                    <td>{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="mtm-modal__txt mt-4">
              <p dangerouslySetInnerHTML={{ __html: option.body_html }} />
            </div>
          </div>
        </div>
        {option.is_soldout ? (
          <div className="detail-row__btn--sm detail-row__btn__bg text-center py-3 w-100">
            sold out
          </div>
        ) : (
          <a
            className="detail-row__btn--sm detail-row__btn__bg text-center py-3 w-100"
            href={`/collections/${option.collection_handle}`}
          >
            Select this fabric
          </a>
        )}
      </div>
    </Modal>
  );
};

const RenderFabric = ({
  option,
  price,
  isClose,
  setIsClose,
  currentId,
  setCurrentId
}) => {
  const [isShow, setIsShow] = useState(false);
  const [mainImage, setMainImage] = useState(option.image_url_1 || noImage);

  const displayImage = mainImage || noImage;

  const handleShowDetail = (event) => {
    const id = event.target.id;
    setIsClose(false);
    setCurrentId(id);
    setIsShow(true);
  };

  return (
    <div className="grid-collection__item col-md-4 col-6" data-collection-handle={option.collection_handle}>
      <div className="grid-collection__content mt-5 mr-4">
        <div className="grid-collection__image-mask">
          <img
            className="grid-collection__image"
            src={displayImage}
            alt={option.title}
          />
          <div className="grid-collection__layer collection-layer px-lg-5 px-md-3">
            {option.is_soldout ? (
              <div className="collection-layer__btn collection-layer__btn__bg text-center py-3 mb-2">
                sold out
              </div>
            ) : (
              <a
                href={`/collections/${option.collection_handle}`}
                className="collection-layer__btn collection-layer__btn__bg text-center py-3 mb-2"
              >
                Select this fabric
              </a>
            )}
            <a
              id={option.product_number}
              className="collection-layer__btn collection-layer__btn__border text-center py-3"
              onClick={handleShowDetail}
            >
              Detail
            </a>
          </div>
        </div>
        {/* START MOBILE LAYOUT */}
        <div className="grid-collection__meta text-center mt-3">
          <div className="grid-collection__title">{option.title}</div>
          {price && <div className="grid-collection__price">{price}</div>}
        </div>
        <div className="detail-row__btn__container--sm d-md-none">
          {option.is_soldout ? (
            <div className="detail-row__btn--sm detail-row__btn__bg text-center py-3 mt-3 mb-2">
              sold out
            </div>
          ) : (
            <a
              href={`/collections/${option.collection_handle}`}
              className="detail-row__btn--sm detail-row__btn__bg text-center py-3 mt-3 mb-2"
            >
              Select this fabric
            </a>
          )}
          <div
            id={option.product_number}
            className="detail-row__btn--sm detail-row__btn__border text-center py-3"
            onClick={handleShowDetail}
          >
            Detail
          </div>
          {currentId === option.product_number && (
            <FabricModal
              option={option}
              price={price}
              isShow={isShow}
              setIsShow={setIsShow}
              mainImage={mainImage}
              setMainImage={setMainImage}
            />
          )}
        </div>
        {/* END MOBILE LAYOUT */}
        {currentId === option.product_number && !isClose && (
          <>
            <div className="detailBar mt-5" />
            <div className="detail-row d-none d-md-block">
              <div className="detail-row__inner">
                <div className="detail-row__wrapper">
                  <div className="detail-row__images">
                    <div className="detail-row__images-main-image">
                      <img src={mainImage} alt={option.title} />
                    </div>
                    <div className="detail-row__images-thumbnails">
                      {option.image_url_1 && (
                        <img
                          src={option.image_url_1}
                          onClick={() => setMainImage(option.image_url_1)}
                          className="thumbnail-image"
                        />
                      )}
                      {option.image_url_2 && (
                        <img
                          src={option.image_url_2}
                          onClick={() => setMainImage(option.image_url_2)}
                          className="thumbnail-image"
                        />
                      )}
                      {option.image_url_3 && (
                        <img
                          src={option.image_url_3}
                          onClick={() => setMainImage(option.image_url_3)}
                          className="thumbnail-image"
                        />
                      )}
                    </div>
                  </div>
                  <div className="detail-row__contents">
                    <p className='detail-row__contents-title'>{option.title}</p>
                    {price && (
                      <p className="detail-row__contents-price">{price}</p>
                    )}
                    <table className="table detail-row__table">
                      <tbody className="hr--primary">
                        {Object.entries({
                          ID: option.product_number,
                          Fabric: option.cloth,
                          Color: option.color,
                          Pattern: option.pattern,
                          Material: option.material,
                          Brand: option.brand,
                          Yarn: option.yarn_count
                        }).map(([key, value]) => (
                          <tr key={key}>
                            <td>{key}</td>
                            <td>{value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <p dangerouslySetInnerHTML={{ __html: option.body_html }} />
                  </div>
                </div>
                <div className="detail-row__btn__container">
                  <Button
                    isSecondary
                    label="Close"
                    onClick={() => setIsClose(true)}
                  />
                  {option.is_soldout ? (
                    <div className="detail-row__btn--sm detail-row__btn__bg text-center py-3 w-100">
                      sold out
                    </div>
                  ) : (
                    <Button
                      label="Select this fabric"
                      href={`/collections/${option.collection_handle}`}
                    />
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RenderFabric;
